/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinvitecreate2Inputs */

const en_membersinvitecreate2 = /** @type {(inputs: Membersinvitecreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create invite link`)
};

const de_membersinvitecreate2 = /** @type {(inputs: Membersinvitecreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungslink erstellen`)
};

/**
* | output |
* | --- |
* | "Create invite link" |
*
* @param {Membersinvitecreate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinvitecreate2 = /** @type {((inputs?: Membersinvitecreate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinvitecreate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinvitecreate2(inputs)
	return de_membersinvitecreate2(inputs)
});
export { membersinvitecreate2 as "membersInviteCreate" }